(function () {
  const GIFT_VARIANT_ID = 48493688586490;
  const ROOT = (window.Shopify && window.Shopify.routes
    ? window.Shopify.routes.root
    : '/');

  async function cartRequest(path, body) {
    const options = {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    };

    if (body !== undefined) {
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(body);
    }

    const response = await fetch(ROOT + path, options);
    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        data.description || data.message ||
        'No se pudo actualizar la cantidad de bolsas.'
      );
    }

    return data;
  }

  async function initGiftWrap() {
    const cartForm = document.querySelector('form[action$="/cart"]');
    if (!cartForm || document.getElementById('gift-wrap-option')) return;

    const container = document.createElement('div');
    container.id = 'gift-wrap-option';
    container.style.cssText = `
      margin:20px 0;
      padding:16px 20px;
      background:#fff;
      border:2px solid #ADD7D69E;
      border-radius:22px;
      font-family:inherit;
      color:#333;
    `;

    container.innerHTML = `
      <div style="font-size:15px;font-weight:500;">
        <span aria-hidden="true">🎁</span>
        Bolsa de regalo · $500 por unidad
      </div>

      <div style="
        display:flex;
        align-items:center;
        flex-wrap:wrap;
        gap:12px;
        margin-top:12px;
      ">
        <label for="gift-wrap-quantity">Cantidad de bolsas</label>
        <input
          id="gift-wrap-quantity"
          type="number"
          min="0"
          step="1"
          value="0"
          inputmode="numeric"
          aria-describedby="gift-wrap-help gift-wrap-status"
          disabled
          style="
            width:80px;
            padding:8px;
            border:1px solid #aaa;
            border-radius:8px;
            background:#fff;
            color:#333;
            font:inherit;
          "
        >
      </div>

      <p id="gift-wrap-help" style="font-size:13px;margin:10px 0 0;">
        Cada unidad corresponde a 1 bolsa. Elige 0 si no necesitas bolsas.
      </p>

      <p id="gift-wrap-status" role="status" aria-live="polite"
         style="font-size:13px;margin:8px 0 0;">
        Consultando cantidad…
      </p>
    `;

    const checkoutButton =
      cartForm.querySelector('[name="checkout"]') ||
      document.querySelector('[name="checkout"]') ||
      document.querySelector('.cart__checkout-button');

    if (checkoutButton) {
      checkoutButton.insertAdjacentElement('beforebegin', container);
    } else {
      cartForm.appendChild(container);
    }

    const input = container.querySelector('#gift-wrap-quantity');
    const status = container.querySelector('#gift-wrap-status');
    let busy = false;
    let knownQuantity = 0;
    let timer;

    function giftItems(cart) {
      return cart.items.filter(
        item => Number(item.variant_id) === GIFT_VARIANT_ID
      );
    }

    function quantityInCart(cart) {
      return giftItems(cart).reduce(
        (total, item) => total + item.quantity, 0
      );
    }

    async function updateQuantity() {
      if (busy) return;

      const quantity = Number(input.value);
      if (
        input.value === '' ||
        !Number.isSafeInteger(quantity) ||
        quantity < 0
      ) {
        status.textContent = 'Ingresa una cantidad entera de 0 o más.';
        return;
      }

      busy = true;
      input.disabled = true;
      container.setAttribute('aria-busy', 'true');
      status.textContent = 'Actualizando bolsas y total del carrito…';

      try {
        const cart = await cartRequest('cart.js');
        const items = giftItems(cart);
        const currentQuantity = quantityInCart(cart);

        if (quantity !== currentQuantity) {
          if (items.length) {
            // Mantener la cantidad elegida en una sola línea.
            const updates = {};
            items.forEach((item, index) => {
              updates[item.key] = index === 0 ? quantity : 0;
            });

            await cartRequest('cart/update.js', { updates });
          } else if (quantity > 0) {
            await cartRequest('cart/add.js', {
              items: [{
                id: GIFT_VARIANT_ID,
                quantity: quantity
              }]
            });
          }

          window.location.reload();
          return;
        }

        knownQuantity = currentQuantity;
        status.textContent = 'Cantidad actualizada.';
      } catch (error) {
        console.error('Error al actualizar bolsas:', error);
        status.textContent = error.message;

        // Recuperar la cantidad real si la solicitud falló.
        try {
          const cart = await cartRequest('cart.js');
          knownQuantity = quantityInCart(cart);
          input.value = knownQuantity;
        } catch (readError) {
          status.textContent +=
            ' Recarga el carrito para comprobar la cantidad antes de pagar.';
        }
      } finally {
        busy = false;
        input.disabled = false;
        container.removeAttribute('aria-busy');
      }
    }

    // Espera a que el cliente termine de escribir.
    input.addEventListener('input', function (event) {
      event.stopPropagation();
      clearTimeout(timer);
      timer = setTimeout(updateQuantity, 900);
    });

    input.addEventListener('change', function (event) {
      event.stopPropagation();
      clearTimeout(timer);
      updateQuantity();
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        clearTimeout(timer);
        updateQuantity();
      }
    });

    // Evita enviar el carrito mientras se guarda la cantidad.
    document.addEventListener('submit', function (event) {
      const form = event.target;
      const isCartForm = form instanceof HTMLFormElement &&
        new URL(form.action, window.location.origin)
          .pathname.replace(/\/$/, '').endsWith('/cart');

      if (!isCartForm) return;

      if (busy || Number(input.value) !== knownQuantity) {
        event.preventDefault();
        event.stopImmediatePropagation();
        clearTimeout(timer);

        if (!busy) updateQuantity();
      }
    }, true);

    try {
      const cart = await cartRequest('cart.js');
      knownQuantity = quantityInCart(cart);
      input.value = knownQuantity;
      input.disabled = false;
      status.textContent = '';
    } catch (error) {
      console.error('Error al consultar bolsas:', error);
      status.textContent =
        'No se pudo consultar la cantidad. Recarga el carrito para intentarlo nuevamente.';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGiftWrap);
  } else {
    initGiftWrap();
  }
})();
